module.exports = __webpack_public_path__ + "assets/f4a6ca8f336341fc9c5b04cf4c249a2c.svg";